import { useState } from 'react';

export function useToggle(initialValue = false, preventPropagation = false): any {
  const [value, setValue] = useState<boolean>(initialValue);

  const toggleValue = (e) => {
    if (e && preventPropagation) {
      e.stopPropagation();
      e.preventDefault();
    }

    setValue(!value);
  };

  return [value, toggleValue];
}
